module.exports = __webpack_public_path__ + "img/decorative-line-one-side.cb5360c4.svg";